export const SUBSCRIPTION_STATUS = {
  PROCESSING: 0,
  ACTIVED: 1,
  CANCELED: 2,
  FAILED: 3,
}
